import { render } from "./MedicalNotesTable.vue?vue&type=template&id=19b18258&scoped=true"
import script from "./MedicalNotesTable.vue?vue&type=script&lang=js"
export * from "./MedicalNotesTable.vue?vue&type=script&lang=js"

import "./MedicalNotesTable.vue?vue&type=style&index=0&id=19b18258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b18258"]])

export default __exports__